import { ui } from '../../styles/ui'

const stripTodoPrefix = (value, fallback) => {
  const text = String(value || fallback || '').trim()
  if (!text) return ''
  return text.replace(/^TODO:\s*/i, '')
}

export default function OperationProgressToast({ toast }) {
  if (!toast) return null

  const parsedCurrent = Number(toast.progressCurrent)
  const parsedTotal = Number(toast.progressTotal)
  const current = Number.isFinite(parsedCurrent) && parsedCurrent > 0 ? parsedCurrent : 0
  const total = Number.isFinite(parsedTotal) && parsedTotal > 0 ? parsedTotal : Math.max(current, 0)
  const percent = total > 0 ? Math.min(100, Math.round((current / total) * 100)) : 0
  const title = stripTodoPrefix(toast.title, 'Operation running')
  const message = stripTodoPrefix(toast.message, 'Background task in progress')

  return (
    <div className={`fixed right-4 z-50 w-[360px] ${ui.states.loading} shadow-sm`} style={{ top: '1rem' }}>
      <p className="text-xs font-semibold uppercase tracking-wide">{title || 'Operation running'}</p>
      <p className="mt-1 text-sm break-words">{message || 'Background task in progress'}</p>
      <div className="mt-3">
        <div className="h-2 w-full rounded bg-surface-elevated">
          <div className="h-2 rounded bg-primary transition-all duration-300" style={{ width: `${percent}%` }} />
        </div>
        <div className="mt-1 text-xs text-muted-foreground">{current} / {total}</div>
      </div>
    </div>
  )
}
